// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.RentCreditReportGetOptInWithCreditTrackingHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking,
  RentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking_Path,
} from '@zg-rentals/ts-rent-payment-client';

import type {
  RentCreditReportGetOptInWithCreditTrackingWebApiRequestDto,
  RentCreditReportGetOptInWithCreditTrackingWebApiResponseDto,
} from '@zg-rentals/ts-rent-payment-client';

export type RentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking_Options = UseQueryOptions<
  RentCreditReportGetOptInWithCreditTrackingWebApiResponseDto,
  unknown,
  RentCreditReportGetOptInWithCreditTrackingWebApiResponseDto,
  Array<string | RentCreditReportGetOptInWithCreditTrackingWebApiRequestDto>
>;

const RentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking_GetKey = (
  postData: RentCreditReportGetOptInWithCreditTrackingWebApiRequestDto,
) => [RentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking_Path, postData];

/**
 * Get opt in status for rent reporting with credit tracking
 */
export const useRentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking = (
  postData: RentCreditReportGetOptInWithCreditTrackingWebApiRequestDto,
  {
    httpClient,
    ...options
  }: Omit<
    RentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking_GetKey(postData),
    queryFn: () => RentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking(postData, httpClient),
  });
};
useRentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking.getKey =
  RentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking_GetKey;
